function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import DialogContent from '@mui/material/DialogContent';
import Fade from '@mui/material/Fade';
import MuiDialog, { dialogClasses } from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';
import { DIALOG_WIDTH } from "../constants/dimensions.js";
import { jsx as _jsx } from "react/jsx-runtime";
var PickersModalDialogRoot = styled(MuiDialog)(_defineProperty(_defineProperty({}, "& .".concat(dialogClasses.container), {
  outline: 0
}), "& .".concat(dialogClasses.paper), {
  outline: 0,
  minWidth: DIALOG_WIDTH
}));
var PickersModalDialogContent = styled(DialogContent)({
  '&:first-of-type': {
    padding: 0
  }
});
export function PickersModalDialog(props) {
  var _slots$dialog, _slots$mobileTransiti;
  var children = props.children,
    onDismiss = props.onDismiss,
    open = props.open,
    slots = props.slots,
    slotProps = props.slotProps;
  var Dialog = (_slots$dialog = slots === null || slots === void 0 ? void 0 : slots.dialog) !== null && _slots$dialog !== void 0 ? _slots$dialog : PickersModalDialogRoot;
  var Transition = (_slots$mobileTransiti = slots === null || slots === void 0 ? void 0 : slots.mobileTransition) !== null && _slots$mobileTransiti !== void 0 ? _slots$mobileTransiti : Fade;
  return /*#__PURE__*/_jsx(Dialog, _extends({
    open: open,
    onClose: onDismiss
  }, slotProps === null || slotProps === void 0 ? void 0 : slotProps.dialog, {
    TransitionComponent: Transition,
    TransitionProps: slotProps === null || slotProps === void 0 ? void 0 : slotProps.mobileTransition,
    PaperComponent: slots === null || slots === void 0 ? void 0 : slots.mobilePaper,
    PaperProps: slotProps === null || slotProps === void 0 ? void 0 : slotProps.mobilePaper,
    children: /*#__PURE__*/_jsx(PickersModalDialogContent, {
      children: children
    })
  }));
}